import clsx from "clsx";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import { forwardRef } from "react";

import { Icon } from "~/assets/icons/Icon";

import Button from "../button/Button";
import styles from "./Snackbar.module.scss";

const statusIcons = {
  success: <Icon iconName="GreenCheckmarkIcon" />,
  default: <Icon iconName="GreenCheckmarkIcon" />,
  reportComplete: <Icon iconName="DangerIcon" />,
  warning: <Icon iconName="WarningIcon" />,
  error: <Icon iconName="DangerIcon" />,
  info: <Icon iconName="InfoIcon" />,
};

const Snackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, forwardedRef) => {
    const { message, variant, id } = props;

    const { closeSnackbar } = useSnackbar();

    return (
      <SnackbarContent
        key={id}
        ref={forwardedRef}
        className={clsx(styles.customSnackbar)}
      >
        <div className={styles.customSnackbarHeader}>
          <div className={styles.customSnackbarHeaderStatus}>
            {statusIcons?.[variant]}
            <span className={styles.customSnackbarHeaderTitle}>{variant}</span>
          </div>
          <Button noHover onClick={() => closeSnackbar(id)}>
            <Icon iconName="PlainCloseIcon" />
          </Button>
        </div>
        <div className={styles.customSnackbarMessage}>{message}</div>
      </SnackbarContent>
    );
  },
);
Snackbar.displayName = "Snackbar";
export default Snackbar;
